module.exports = __webpack_public_path__ + "img/alcance.7ddbc61c.svg";